export {
  isMartyCaganAtfSlotActive,
  MARTY_CAGAN_ATF_SLOT_END_ISO_LOCAL,
  MARTY_CAGAN_ATF_SLOT_START_ISO_LOCAL,
} from '~/utils/marty-cagan-slot';
